import axios from "./axios"

function create (data) {
    return axios().post("/credit-notes", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });    
}

function findByID(id) {
    return axios().get(`/credit-notes/${id}`);
}

function remove(data) {
    return axios().delete(`/credit-notes/${data.id}`);
}

function update(data) {
    return axios().put(`/credit-notes/${data.id}`, data);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit; 
    
    return axios().get("/credit-notes", {
        params
    })
}

function post(data) {
    return axios().put(`/credit-notes/${data.id}/post`);
}
function print(data) {
    return axios().get(`/credit-notes/${data.id}`, {
        headers: {
            "Accept": "text/html"
        }
    });
}
function states() {
    return axios().get("/credit-note-states")
}

export default {
    create,
    findByID,
    remove,
    index,
    update,
    post,
    print,
    states
}